import AdminCard from '../../components/AdminCard'
import AdminTopMenu from '../../components/AdminTopMenu'

const Dashboard = () => {
  return (
    <>
      <div className="d-md-none">
        <AdminTopMenu title="Bem vindo(a), usuario" />
        <AdminCard
          descr="Avisos"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_avisos.svg"
          navigateTo="/admin/dashboard/avisos"
          active={true}
        />
        <AdminCard
          descr="Sobre"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_sobre.svg"
          navigateTo="/admin/dashboard/sobre"
          active={true}
        />
        <AdminCard
          descr="Turmas"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_turmas.svg"
          navigateTo="/admin/dashboard/turmas"
          active={true}
        />
        <AdminCard
          descr="Contato"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_contato.svg"
          navigateTo="/admin/dashboard/contato"
          active={true}
        />
        <AdminCard
          descr="Fotos do carrossel"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_fotos.svg"
          navigateTo="/admin/dashboard/carousel"
          active={false}
        />
        <AdminCard
          descr="Trabalhe conosco"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_trabalhe.svg"
          navigateTo="/admin/dashboard/trabalhe-conosco"
          active={false}
        />
        <AdminCard
          descr="Listagem de candidatos"
          imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_candidatos.png"
          navigateTo="/admin/dashboard/fichas-candidatos"
          active={false}
        />
      </div>
      <div className="d-none d-md-grid">
        <AdminTopMenu title="Bem vindo(a), usuario" />
        <div className="row d-flex">
          <div className="col-4 mb-3">
            <AdminCard
              descr="Avisos"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_avisos.svg"
              navigateTo="/admin/dashboard/avisos"
              active={true}
            />
            <AdminCard
              descr="Sobre"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_sobre.svg"
              navigateTo="/admin/dashboard/sobre"
              active={true}
            />
          </div>
          <div className="col-4 mb-3">
            <AdminCard
              descr="Turmas"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_turmas.svg"
              navigateTo="/admin/dashboard/turmas"
              active={true}
            />
            <AdminCard
              descr="Contato"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_contato.svg"
              navigateTo="/admin/dashboard/contato"
              active={true}
            />
          </div>
          <div className="col-4 mb-3">
            <AdminCard
              descr="Fotos do carrossel"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_fotos.svg"
              navigateTo="/admin/dashboard/carousel"
              active={false}
            />
            <AdminCard
              descr="Trabalhe conosco"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_trabalhe.svg"
              navigateTo="/admin/dashboard/trabalhe-conosco"
              active={false}
            />
          </div>
          <div className="col-4 mb-3">
            <AdminCard
              descr="Listagem de candidatos"
              imgLink="https://static-file-vault.vercel.app/cdtchechela/admin_candidatos.png"
              navigateTo="/admin/dashboard/fichas-candidatos"
              active={false}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
